import React from 'react';
import PropTypes from 'prop-types';
import { i18n as I18n } from '../../../utils/i18n';

// components
import FeatureIcon from '../featureIcon';

export const FavouriteButton = ({
  favouritedState,
  type,
  handleFavouriteButtonClick,
}) => {
  return (
    <button
      data-testid="favouriteButton"
      className="favourite-button"
      onClick={handleFavouriteButtonClick}
    >
      {favouritedState && (
        <FeatureIcon
          type="favourite-on"
          name={`${I18n.t('favourite.remove_from_my_saved')} ${type}`}
          displaySvgIcon
        />
      )}
      {!favouritedState && (
        <FeatureIcon
          type="favourite-off"
          name={`${I18n.t('favourite.add_to_my_saved')} ${type}`}
          displaySvgIcon
        />
      )}
    </button>
  );
};

export default FavouriteButton;

FavouriteButton.propTypes = {
  favouritedState: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  handleFavouriteButtonClick: PropTypes.func,
};
